import React from 'react';
import { Handle, Position } from 'reactflow';
import { SettingOutlined, CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

const TransformerNode = ({ data, selected }) => {
  // Check if the transformer is configured
  const isConfigured = (data.config?.transformationPlan);
  // console.log('data: ', data)
  // Determine colors based on configuration status
  const nodeColor = isConfigured ? '#1890ff' : '#d9d9d9';
  const iconColor = isConfigured ? '#1890ff' : '#999';
  const textColor = isConfigured ? '#333' : '#999';
  
  // Get display information
  const getDisplayName = () => {
    // If node has a custom name, use it
    if (data.config?.node_name) {
      return data.config.node_name;
    }
    
    if (!data.config?.transformationPlan) {
      return 'Transformer';
    }
    
    const { transformationType, steps } = data.config.transformationPlan;
    const typeNames = {
      'aggregation': 'Aggregation',
      'filtering': 'Filtering', 
      'data_cleaning': 'Data Cleaning',
      'transpose_data': 'Transpose Data'
    };
    
    return typeNames[transformationType] || 'Transformer';
  };
  
  const getConfigInfo = () => {
    if (!data.config?.transformationPlan) {
      return 'Not configured';
    }
    
    const { steps, summary } = data.config.transformationPlan;
    if (summary) {
      return summary.length > 50 ? summary.substring(0, 47) + '...' : summary;
    }
    if(!steps){
      return ''
    }

    return `${steps.length} transformation step${steps.length === 1 ? '' : 's'}`;
  };

  return (
    <div className={`react-flow__node-transformer ${selected ? 'selected' : ''}`}
         style={{
           borderColor: nodeColor,
           backgroundColor: isConfigured ? 'white' : '#f5f5f5',
           opacity: isConfigured ? 1 : 0.7
         }}>
      <Handle
        type="target"
        position={Position.Left}
        style={{
          background: nodeColor,
          border: '2px solid #fff',
          width: '8px',
          height: '8px'
        }}
      />
      
      <div style={{ 
        padding: '12px', 
        display: 'flex', 
        alignItems: 'center', 
        gap: '8px',
        minWidth: '140px'
      }}>
        {isConfigured ? (
          <CheckCircleOutlined style={{ fontSize: '16px', color: iconColor }} />
        ) : (
          <SettingOutlined style={{ fontSize: '16px', color: iconColor }} />
        )}
        <div>
          <div style={{ 
            fontWeight: '500', 
            fontSize: '13px',
            color: textColor
          }}>
            {getDisplayName()}
          </div>
          <div style={{ 
            fontSize: '11px', 
            color: isConfigured ? '#666' : '#999',
            fontStyle: isConfigured ? 'normal' : 'italic',
            maxWidth: '180px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}>
            {getConfigInfo()}
          </div>
        </div>
      </div>
      
      <Handle
        type="source"
        position={Position.Right}
        style={{
          background: nodeColor,
          border: '2px solid #fff',
          width: '8px',
          height: '8px'
        }}
      />
    </div>
  );
};

export default TransformerNode;